// display hero media (video or image)
import React from 'react';
import { getStrapiImage } from "@/utils/strapiFunctions";

export default function HeroMedia({ media }) {
  return (
    <div className="sm:h-[600px] sm:w-full md:h-[496px] lg:h-[756px]">
      {media?.data?.attributes?.mime?.includes('video') && <video
        muted
        autoPlay
        loop
        webkit-playsinline
        playsinline
        id="myVideo"
        poster="/next_assets/img/brand-assets/hero_bg.jpg"
        className="top-0 object-cover w-full h-full"
      >
        <source
          src={media?.data?.attributes?.url}
          type={media?.data?.attributes?.mime}
        />
      </video>}

      {media?.data?.attributes?.mime?.includes('image') && <img
        src={getStrapiImage(media, "large")}
        alt="Ambulante hero media"
        className="top-0 object-cover w-full h-full"
      />}

    </div>
  );
}
